module.exports = __webpack_public_path__ + "static/media/Hexion BV.13b5fb8a.webp";